/**
 * @generated SignedSource<<851034e9e2ef93dc1513330daff4519e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type RedemptionTypeKey = "CHARITY" | "GIFT_CARD" | "MOBILE" | "PAYPAL" | "VENMO";
export type RedemptionTypeStatus = "AVAILABLE" | "OFFLINE" | "REQUIRES_VERIFICATION";
import { FragmentRefs } from "relay-runtime";
export type RedemptionTypesButtons_redemptionTypes$data = {
  readonly id: string;
  readonly types: ReadonlyArray<{
    readonly name: RedemptionTypeKey;
    readonly status: RedemptionTypeStatus;
  }>;
  readonly " $fragmentType": "RedemptionTypesButtons_redemptionTypes";
};
export type RedemptionTypesButtons_redemptionTypes$key = {
  readonly " $data"?: RedemptionTypesButtons_redemptionTypes$data;
  readonly " $fragmentSpreads": FragmentRefs<"RedemptionTypesButtons_redemptionTypes">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./RedemptionTypesRefetchQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "RedemptionTypesButtons_redemptionTypes",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RedemptionType",
      "kind": "LinkedField",
      "name": "types",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "RedemptionTypes",
  "abstractKey": null
};

(node as any).hash = "79be6613dd3afda6fac046d57e192e0b";

export default node;
